import React from 'react'
import {Box} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import {QuestionnaireRow} from './questionnairesColumns'

interface QuestionnaireDialogNewProps {
  open: boolean
  onClose: () => void
  questionnaire?: QuestionnaireRow
}

/**
 * New-style equivalent of src/components/templates/SurveyDialog/SurveyDialog.tsx.
 * Unlike the per-patient tab's SurveyDialogNew (which only ever shows compiled/
 * confirmed surveys), the top-level list can also contain TO_COMPILE rows — same
 * as the legacy page, those open the fill-form visualizer instead of the read-only
 * one.
 */
export default function QuestionnaireDialogNew({open, onClose, questionnaire}: QuestionnaireDialogNewProps): JSX.Element {
  const title = questionnaire?.name || 'Questionario'
  const url = questionnaire?.state === 'TO_COMPILE'
    ? `/form-service/#/visualizer/fill-form/?formSchemaId=${questionnaire?.formSchemaId}`
    : `/form-service/#/visualizer/${questionnaire?.formDataId}`

  return (
    <AppDialog open={open} onClose={onClose} title={title} maxWidth="lg">
      {questionnaire && (questionnaire.formDataId || questionnaire.formSchemaId) && (
        <Box
          component="iframe"
          src={url}
          title={title}
          sx={{width: '100%', height: '70vh', border: 'none'}}
        />
      )}
    </AppDialog>
  )
}
